import { Permission, UserType } from "generated/graphql";

export function isOwner(permissions: Permission[]): boolean {
  return permissions.indexOf(Permission.Owner) !== -1;
}

export function isSupport(permissions: Permission[]): boolean {
  return permissions.indexOf(Permission.Support) !== -1;
}

export function isAdmin(userInfo: { userType: UserType }): boolean {
  return userInfo.userType === UserType.Admin;
}
